import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Form } from 'react-bootstrap';
import FalconCloseButton from 'components/common/FalconCloseButton';

const ModalEliminarCliente = ({
    showModalEliminar,
    setShowModalEliminar,
    handleSubmit,
    onSubmitEliminar,
    reset
}) => {
    return (
        <Modal
            show={showModalEliminar}
            onHide={() => setShowModalEliminar(false)}
            size="md"
            backdrop="static"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Form noValidate onSubmit={handleSubmit(onSubmitEliminar)}>
                <Modal.Header>
                    <Modal.Title>Eliminar Cliente</Modal.Title>
                    <FalconCloseButton
                        className="btn btn-circle btn-sm transition-base p-0"
                        onClick={() => { setShowModalEliminar(false); reset() }}
                    />
                </Modal.Header>
                <Modal.Body>
                    <h4>&iquest;Est&aacute; seguro que desea eliminar el cliente?</h4>
                    <div className="row">
                        <div className="col-md-12">
                            Es importante que el cliente no tenga vinculado ninguna licencia, orden de venta o servicio
                            para poder eliminarlo.
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => { setShowModalEliminar(false); reset() }} variant='primary'>
                        Cerrar
                    </Button>
                    <Button type="submit" variant='danger'>
                        Eliminar cliente
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

ModalEliminarCliente.propTypes = {
    showModalEliminar: PropTypes.bool.isRequired,
    setShowModalEliminar: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    onSubmitEliminar: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired
};

export default ModalEliminarCliente;
